// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"0dcdd929","498":"9757e21f","703":"44be0a77","787":"9eb0e1d9"}[chunkId] + ".chunk.js";
};